import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice.service';
import { GeneralService } from 'src/app/services/general.service';
import { TeamsService } from 'src/app/services/crew-services/teams.service';
import { mergeMap, take } from 'rxjs/operators';
import { EXTRASALESPERSONTEAMHASHMAP, COMPAREARRMATCH_APPEND, REFACTORTEAMSARRRESPONSE, INVOICECHARTDATA } from 'src/app/helpers/helperResources';
import { CurrencyService } from 'src/app/services/currency.service';
import DateUtils from 'src/app/utils/date';
import { BehaviorSubject, Observable, of } from "rxjs";

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexXAxis,
  ApexYAxis,
  ApexPlotOptions,
  ApexLegend
} from "ng-apexcharts";
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ClientService } from 'src/app/services/client-services/clients.service';
import { selectConfig } from 'src/app/utils/utils';
import { YEAR } from 'src/app/data/industries';
import { ReportCurrencyFormatter } from 'src/app/models/reportCurrencyFormatter';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[];
  legend: ApexLegend;
};


@Component({
  selector: 'app-invoices-report',
  templateUrl: './invoices-report.component.html',
  styleUrls: ['./invoices-report.component.css']
})
export class InvoicesReportComponent implements OnInit {
  dateUtil = new DateUtils;
  public chart_labelsMonth = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  public chart_labelsQuater = ["Q1", "Q2", "Q3", "Q4"];
  public chartOptions: Partial<ChartOptions> = {
    series: [
      {
        name: "Total Invoice",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "Overdues",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    colors: [
      "#0866C6", "#DC3545"
    ],
    legend: {
      show: true,
      position: 'bottom',
    }
  };
  config = {
    ...selectConfig,
    placeholder: "Search Clients",
    noResultsFound: "Type here to search",
  };
  cOptions: Partial<ChartOptions>;
  barChartYear = new Date().getFullYear();
  dataSource: any;
  totalInvoice = {
    amount: 0,
    count: 0,
  };
  totalOverdues = {
    amount: 0,
    count: 0,
  };
  baseCurrency = "USD";
  // selectedUserDetails;
  teamID;
  userId;
  selectedType = 'selfteam';
  viewType = 'month';
  clientList$: Observable<any>;
  currencyIdAttribute = "ngx-select";
  selectedClientId;
  loadingChart = false;
  years;

  constructor(
    private invoiceServ: InvoiceService,
    private gs: GeneralService,
    private currencyServ: CurrencyService,
    private selectedUsersServ: PerformanceReportService,
    private clientServ: ClientService
  ) {
    this.years = this.dateUtil.getYears();
    this.cOptions = {
      series: [
        {
          name: "Total Invoice",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Overdues",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      xaxis: {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'Total Invoice and Overdues',
        },
      },
      yaxis: {
        title: {
          text: `Value in Base Currency`,
        },
      }
    }
    this.userId = this.gs.user.id;
    this.currencyServ.org_currencies.subscribe((org_currencies: any) => {
      this.baseCurrency = org_currencies.base_currency;
      if (org_currencies) {
        this.cOptions.yaxis = {
          title: {
            text: `Value in Base Currency ${this.baseCurrency}`,
          },
          labels: {
            formatter: function (value) {
              const currencyF = new ReportCurrencyFormatter();
              return currencyF.handleFormatter(value)
              // return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              // new Intl.NumberFormat('en-US', { maximumSignificantDigits: 2 }).format(value)
            }
          },
        }
      }
    });

  }


  ngOnInit() {
    this.setView();
  }

  public getAllInvoiceOverview() {
    this.loadingChart = false;
    this.selectedUsersServ.selected_users.subscribe((res) => {
      // this.selectedUserDetails = res;
      if (res.length !== 0) {
        const { ids, type } = res;
        let query;
        if (type === 'salesperson') {
          query = `${this.getDateFilterRange}&createdBy=${ids.toString()}`
        } else {
          query = `${this.getDateFilterRange}&teamId=${ids.toString()}`
        }
        this.invoiceServ
          .getInvoiceByFilter(query)
          .pipe(take(1))
          .subscribe(
            (res: any) => {
              if (res) {
                this.dataSource = res.payload;
                this.loadingChart = true;
                let dataSourceInBaseCurr = this.currencyServ.dataSourceInBase(this.dataSource);
                //Chart Data
                const data = {
                  totalInvoice: [],
                  overdues: [],
                };

                data.totalInvoice = INVOICECHARTDATA(
                  dataSourceInBaseCurr,
                  "totalInvoice",
                  this.viewType
                );
                data.overdues = INVOICECHARTDATA(
                  dataSourceInBaseCurr,
                  "overdues",
                  this.viewType
                );
                this.cOptions.series = [{
                  name: "Total Invoice",
                  data: [...data.totalInvoice]
                }, {
                  name: "Overdues",
                  data: [...data.overdues]
                }
                ];
              } else {
                this.loadingChart = true;
                this.cOptions.series = [
                  {
                    name: "Total Invoice",
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                  },
                  {
                    name: "Overdues",
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                  }
                ];

              }
            },
            (error) => {
            }
          );

      }
    });
  }

  private get getDateFilterRange() {
    const startYr = Date.parse(
      new Date(`01/01/${this.barChartYear}`).toISOString()
    );
    const endYr = Date.parse(
      new Date(`12/31/${this.barChartYear}`).toISOString()
    );
    const jsonValueRange = {
      createdOn: { from: startYr, to: endYr },
    };
    return `range=${JSON.stringify(jsonValueRange)}`;
  }

  handleTotalInvoiceAmount(arr) {
    this.totalInvoice.count = arr.length;
    arr.forEach((currentValue: any) => {
      const { totalCost } = currentValue;
      this.totalInvoice.amount += totalCost;
    });
  }

  handleTotalOverDueAmount(arr) {
    const today = Date.parse(new Date().toISOString());
    arr.forEach((currentValue) => {
      const { paymentDueDate, balanceDue } = currentValue;
      if (today > paymentDueDate && balanceDue > 0) {
        this.totalOverdues.count++;
        this.totalOverdues.amount += balanceDue;
      }
    });
  }

  setView() {
    if (this.viewType === 'month') {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'Total Invoice and Overdues',
        },
      }
    } else if (this.viewType === 'quarter') {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsQuater],
        title: {
          text: 'Total Invoice and Overdues',
        },
      }
    }
    this.getAllInvoiceOverview();

  }

  clientLookUp(value) {
    if (!value) {
      return;
    }
    this.clientList$ = this.clientServ.getClientWildcard(value).pipe(
      mergeMap((data: { payload: any[] }) =>
        of(
          data.payload.map((dat) => ({
            id: dat.id,
            name: dat.name,
            email: dat.email,
            invoiceTemplateId: dat.invoiceTemplateId,
          }))
        )
      )
    );
  }
}
